import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { parse, format } from "date-fns";

const CustomTimePicker = ({ errors, setErrors, data, setData, name, validators, nullable = false, ...rest }) => {
    const stringToDate = (timeString) => {
        if (!timeString) return null;
        try {
            return parse(timeString, 'HH:mm', new Date());
        } catch (e) {
            return null;
        }
    };

    const handleChange = (inputValue) => {
        if (nullable && !inputValue) {
            setData({ ...data, [name]: null });
        } else {
            setData({ ...data, [name]: inputValue });
        }
    };

    const handleBlur = (inputValue) => {
        for (let validator of validators[name]) {
            const { valid, error } = validator(inputValue);
            if (!valid) {
                setErrors({ ...errors, [name]: error });
                break;
            } else setErrors({ ...errors, [name]: '' });
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
                value={stringToDate(data[name])}
                onChange={(newValue, inputValue) => {
                    // console.log(`newValue: ${format(newValue, "HH:mm")}, inputValue: ${inputValue}`);
                    handleBlur(inputValue || format(newValue, "HH:mm"));
                    handleChange(inputValue || format(newValue, "HH:mm"));
                }}
                onClose={handleBlur}
                ampm={false}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        error={Boolean(errors[name])}
                        helperText={errors[name] && errors[name]}
                        {...rest}
                    />
                )}
            />
        </LocalizationProvider>
    );
};

export default CustomTimePicker; 